<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'TlbsCol',
  inheritAttrs: false,
})
</script>
<template>
  <t-col
    :span="span"
  >
    <div
      class="tlbs-col-container"
      v-bind="$attrs"
    >
      <slot />
    </div>
  </t-col>
</template>

<script setup lang="ts"  name="TlbsCol" inheritAttrs="false">
interface Props {
  span?: number;
}

withDefaults(defineProps<Props>(), {
  span: 0,
});
</script>
